import { render } from "./ExploreMenuConfig.vue?vue&type=template&id=44a53885&scoped=true"
import script from "./ExploreMenuConfig.vue?vue&type=script&lang=js"
export * from "./ExploreMenuConfig.vue?vue&type=script&lang=js"

import "./ExploreMenuConfig.vue?vue&type=style&index=0&id=44a53885&scoped=true&lang=css"

import exportComponent from "/home/bazyaarc/sources/bazyaar-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a53885"]])

export default __exports__